import escapeRegExp from 'lodash-es/escapeRegExp.js'

export const searchIn = (text, search) => new RegExp(escapeRegExp(search), 'i').test(text)
